function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

module.exports = _taggedTemplateLiteralLoose;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/taggedTemplateLiteralLoose.js
// module id = 69
// module chunks = 70144966829960 73875541826398 169315112914517